import { render, staticRenderFns } from "./SelectInstitutionComponent.vue?vue&type=template&id=8a8b91fc&"
import script from "./SelectInstitutionComponent.vue?vue&type=script&lang=js&"
export * from "./SelectInstitutionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports